import React, { useEffect, useState } from "react";
import AccordionComponent from "../../../../common/Accordion";
import {
  Button,
  Col,
  Container,
  Row,
  Modal,
  ToggleButtonGroup,
  ToggleButton,
  ButtonGroup,
} from "react-bootstrap";
import TextInput from "../../../../common/TextInput";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import Snackbar from "../../../../common/Snackbar";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import EditableFileTable from "../../../../common/CaseNotesTable";
import {
  fetchNotesCategoryList,
  getDocumentCategoryList,
} from "../../../../services/CaseNotesApi";
import {
  addCaseNotesAttachments,
  fetchDocumentCategoryList,
} from "../../../../services/UploadRecordsApi";
import { fetchPartiesDetails } from "../../../../services/CaseInformationApi";
import {
  addDWCExtension,
  updateDwcExtension,
  getDwcExtensionDetails,
  getDWCExtensionLogs,
  getEditorExtensionEmail,
} from "../../../../services/EditorWorkFlowAPI";
import { downloadExtensionForm } from "../../../../services/AppointmentsAPI";
import { PICKLIST_GROUP_NAME } from "../actions/constant";
import { fetchPickListByGroupName } from "../../../../services/CaseInformationApi";
import DataTable from "../../../../common/DataTable";
import { LOG_HEADERS } from "../actions/constant";
import { id } from "date-fns/locale";
import { EDITOR_REPORT_STATUS } from "../../../../common/Constant";

interface PartyOption {
  value: string;
  label: string;
  partyCode: string;
}
interface DataTableProps {
  selectedRowIds?: any;
  selectedRows?: any;
  dwcExtensionIds?: any;
  subjectQmeScheduleID?: any;
  onClose: () => void;
  onSaveSuccess: (value: string) => void;
  dwcStatus?: any;
  caseInfoId?: any;
}
interface PicklistItem {
  id: number;
  value: number;
  label: string;
}

const EditorDWCExtensionRequest: React.FC<DataTableProps> = ({
  selectedRowIds = [],
  selectedRows,
  dwcExtensionIds,
  subjectQmeScheduleID,
  onClose,
  onSaveSuccess,
  dwcStatus,
  caseInfoId,
}) => {
  const [extensionRequestedDate, setextensionRequestedDate] =
    useState<Date | null>(null);
  const [newDueDate, setnewDueDate] = useState<Date | null>(null);
  const [currentDueDate, setcurrentDueDate] = useState<Date | null>(null);

  const [approvedonDate, setApprovedonDate] = useState<Date | null>(null);

  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [entityName, setEntityName] = useState("");
  const [showEntityName, setShowEntityName] = useState("");
  const [typeofTest, settypeofTest] = useState("");
  const [activeKey, setActiveKey] = useState<string | null>("0");
  const [is30Day, setis30Day] = useState<boolean>(true);
  const [is15Day, setis15Day] = useState<boolean>(false);
  const [isMedical, setisMedical] = useState<boolean>(false);
  const [comments, setcomments] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [isDeath, setisDeath] = useState<boolean>(false);
  const [isNatural, setisNatural] = useState<boolean>(false);
  const [isLab, setisLab] = useState<boolean>(false);
  const [isReport, setisReport] = useState<boolean>(false);
  const [addnotefileKey, setaddnotefileKey] = useState<string | null>("0");
  const [senderOptions, setSenderOptions] = useState<PartyOption[]>([]);
  const [sender, setSender] = useState<string | null | number>();
  const [senderCode, setSenderCode] = useState<string>("");
  const [fileIds, setFileIds] = useState<string[]>([]);
  const [status, setStatus] = useState("");
  const [statusName, setStatusName] = useState("");
  const [addlogKey, setaddlogKey] = useState<string | null>("0");

  const [dwcExtensionId, setDwcExtensionId] = useState<string | null | number>(
    null,
  );

  console.log(selectedRows, "selectedRows");

  const [requestedDaysOptions, setRequestedDaysOptions] = useState<
    PicklistItem[]
  >([]);
  const [requestedDays, setRequestedDays] = useState<number | null>(null);

  const [requestedDaysValue, setRequestedDaysValue] =
    useState<string>("30 Days");

  const handleFileIdsUpdate = (ids: string[], isSaveDisabled?: boolean) => {
    setFileIds(ids);
  };
  const [documentCategoryOptions, setDocumentCategoryOptions] = useState<any[]>(
    [],
  );
  const [statusOptions, setStatusOptions] = useState<any[]>([]);

  const [documentCategory, setDocumentCategory] = useState<
    string | null | number
  >(null);
  const [result, setResult] = useState<any>({});
  const [isCancel, setIsCancel] = useState<boolean>(false);
  const [documentTypeOptions, setDocumentTypeOptions] = useState<
    {
      value: string;
      label: string;
      documentCategory: string;
      documentTypeDescription: string;
    }[]
  >([]);
  const [documentType, setDocumentType] = useState<string | null | number>(
    null,
  );
  const [thirtyDayReasons, setThirtyDayReasons] = useState<PicklistItem[]>([]);
  const [fifteenDayReasons, setFifteenDayReasons] = useState<PicklistItem[]>(
    [],
  );
  const [selectedReason, setSelectedReason] = useState<number | null>(null);
  const isReasonDisabled =
    dwcStatus === "Denied" ||
    dwcStatus === "Approved" ||
    (statusName === "Approved" && dwcExtensionId !== null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchDocumentCategoryList();
        const dwcExtension = data?.find(
          (item) => item.label === "DWC Extension",
        );

        if (dwcExtension) {
          setDocumentTypeOptions([dwcExtension]);

          setDocumentType(dwcExtension.value);
        }

        const partiesList = await fetchPartiesDetails(selectedRowIds);
        setSenderOptions(partiesList || []);
        setSender(String(loggedInUserid));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    const loadDocumentCategoryList = async () => {
      try {
        const data = await fetchNotesCategoryList();
        setDocumentCategoryOptions(data);
      } catch (error) {
        console.error("Failed to fetch document category list:", error);
      }
    };

    loadDocumentCategoryList();
  }, []);
  const [showModalNew, setShowModalNew] = useState<boolean>(false);
  const handleCancelButton = () => {
    setShowModalNew(true);
  };
  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };
  const handleConfirmCancelButton = async () => {
    setIsCancel(true);
    setShowModalNew(false);

    // Reset fields to initial values
    setDocumentCategory(null);
    setFileIds([]);
    setSnackbarOpen(false);
    setSnackbarMessage("");
    setResult([]);
  };
  const [logRows, setLogRows] = useState<any[]>([]);
  const fetchExtensionDetails = async (id: number) => {
    try {
      const result = await getDwcExtensionDetails(id);
      const data = result.result;

      var extensionRequestedDays = data?.extensionRequestedDays;
      setRequestedDays(data?.extensionRequestedDaysId);
      setRequestedDaysValue(data?.extensionRequestedDays);

      if (extensionRequestedDays != undefined) {
        extensionRequestedDays = data?.extensionRequestedDays;
      } else {
        extensionRequestedDays = 30;
      }

      setcurrentDueDate(
        selectedRows?.[0]?.dueDate
          ? new Date(selectedRows?.[0]?.dueDate)
          : null,
      );
      if (selectedRows?.[0]?.dueDate && extensionRequestedDays) {
        const baseDate = new Date(selectedRows?.[0]?.dueDate);

        const newDate = new Date(baseDate);
        const daysToAdd = parseInt(String(extensionRequestedDays), 10);
        newDate.setDate(baseDate.getDate() + daysToAdd);

        setnewDueDate(newDate);
      } else {
        setnewDueDate(null);
      }
      if (data.dwcExtensionId != 0) {
        setResult(data);
        setStatus(data.dwcExtensionStatusId);
        setStatusName(data.dwcExtensionStatus);
        setDwcExtensionId(data.dwcExtensionId);
        setRequestedDays(data?.extensionRequestedDaysId);
        setRequestedDaysValue(data.extensionRequestedDays);
        setSelectedReason(Number(data.extensionRequestedReasonId));
        setnewDueDate(data.newDueDate);
        setextensionRequestedDate(data.dateRequested);
        setcurrentDueDate(data.dueDate);
        if (data?.attachmentdetails) {
          const attachments = JSON.parse(data.attachmentdetails);
          if (Array.isArray(attachments) && attachments.length > 0) {
            setDocumentType(attachments[0].documenttypeid);
          }

          if (Array.isArray(attachments) && attachments.length > 0) {
            setSender(String(attachments[0].senderkeyid));
          }
        }
        settypeofTest(data.typeOfTest || ""); // ""
        setcomments(data.comments || "");
        setextensionRequestedDate(
          data.dateRequested ? new Date(data.dateRequested) : null,
        );

        setApprovedonDate(data.approvedOn ? new Date(data.approvedOn) : null);
        if (data.extensionRequestedDays === "30 Days") {
          settypeofTest(data.typeOfTest || "");
        }
      } else {
        setRequestedDaysValue("30 Days");
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Failed to load extension details");
      setError("error");
      setSnackbarOpen(true);
    }
  };
  const fetchLogsData = async (id?: number) => {
    try {
      const finalId = id ?? Number(subjectQmeScheduleID);
      const listData: any[] = await getDWCExtensionLogs(finalId);

      const formattedData = listData.map((item: any) => ({
        ...item,
        when: item.when ? dateTimeFormatted(item.when) : "-",
      }));

      setLogRows(formattedData);
    } catch (error) {
      console.error("Error fetching logs data:", error);
    }
  };
  const dateTimeFormatted = (isoString: string): string => {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString("en-US");
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate} ${formattedTime}`;
  };
  useEffect(() => {
    if (subjectQmeScheduleID) {
      fetchExtensionDetails(Number(subjectQmeScheduleID));
    }
  }, [subjectQmeScheduleID]);
  useEffect(() => {
    if (subjectQmeScheduleID) {
      fetchLogsData(Number(subjectQmeScheduleID));
    }
  }, [subjectQmeScheduleID]);

  const renderAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}
              <span className="fw-normal">
                {showEntityName ? ` - ${showEntityName} ` : ""}
              </span>
            </>
          ),
      }))}
      activeKey={activeKey}
      onSelect={(key) => setActiveKey(key as string)}
    />
  );
  const downloadExtensionFormpdf = () => {
    setSnackbarMessage("Generating Extension Form");
    setError("success");
    setSnackbarOpen(true);
    downloadExtensionForm([Number(dwcExtensionId)]);
  };

  const addnotefileAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}
              <span className="fw-normal">
                {showEntityName ? ` - ${showEntityName} ` : ""}
              </span>
            </>
          ),
      }))}
      activeKey={addnotefileKey}
      onSelect={(key) => setaddnotefileKey(key as string)}
    />
  );

  const addlogAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}
              <span className="fw-normal">
                {showEntityName ? ` - ${showEntityName} ` : ""}
              </span>
            </>
          ),
      }))}
      activeKey={addlogKey}
      onSelect={(key) => setaddlogKey(key as string)}
    />
  );

  const userID = useSelector((state: RootState) => state.auth.userid);

  const params = {
    status: {
      groupName: PICKLIST_GROUP_NAME.DWCExtensionStatus,
      triggerById: userID,
    },
    requesteddays: {
      groupName: PICKLIST_GROUP_NAME.DWCExtensionRequestedDays,
      triggerById: userID,
    },
    thirtydays: {
      groupName: PICKLIST_GROUP_NAME.DWCExtension_30daysReasons,
      triggerById: userID,
    },
    fifteendays: {
      groupName: PICKLIST_GROUP_NAME.DWCExtension_15daysReasons,
      triggerById: userID,
    },
  };
  useEffect(() => {
    if (userID) fetchPicklistData();
  }, [userID]);
  const fetchPicklistData = async () => {
    try {
      const statusData = await fetchPickListByGroupName(params.status);
      const requesteddaysData = await fetchPickListByGroupName(
        params.requesteddays,
      );
      const thirtydaysData = await fetchPickListByGroupName(params.thirtydays);
      const fifteendaysData = await fetchPickListByGroupName(
        params.fifteendays,
      );

      const filteredStatus = statusData.filter(
        (item: PicklistItem) => item.label.toLowerCase() !== "not applicable",
      );

      setStatusOptions(filteredStatus);
      setRequestedDaysOptions(requesteddaysData);

      setThirtyDayReasons(thirtydaysData);
      setFifteenDayReasons(fifteendaysData);
      const default30 = requesteddaysData.find((item: PicklistItem) =>
        item.label.toLowerCase().includes("30"),
      );

      if (default30) {
        setis15Day(false);
        setRequestedDays(default30.value);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const formatDateForApi = (date: Date | string | null) => {
    if (!date) return null;

    const parsedDate = typeof date === "string" ? new Date(date) : date;

    // ❗ invalid date safety
    if (isNaN(parsedDate.getTime())) return null;

    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");
    const hours = String(parsedDate.getHours()).padStart(2, "0");
    const minutes = String(parsedDate.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:00`;
  };

  const handleCancel = () => {
    const DEFAULT_DAYS_LABEL = "30 Days";

    setStatus("");
    setRequestedDays(0);
    setRequestedDaysValue(DEFAULT_DAYS_LABEL);
    setSelectedReason(0);
    settypeofTest("");
    setcomments("");
    setextensionRequestedDate(null);

    // ✅ use local value, NOT state
    const daysToAdd = parseInt(DEFAULT_DAYS_LABEL, 10);

    if (!isNaN(daysToAdd) && selectedRows?.[0]?.dueDate) {
      const baseDate = new Date(selectedRows[0].dueDate);
      const newDate = new Date(baseDate);

      newDate.setDate(baseDate.getDate() + daysToAdd);
      setnewDueDate(newDate);
    } else {
      setnewDueDate(null);
    }

    setApprovedonDate(null);
    setDocumentType(null);
    setFileIds([]);
  };

  const calculateNewDueDate = (
    dueDate: string | Date | undefined,
    requestedDaysValue: string,
  ): Date | null => {
    if (!dueDate || !requestedDaysValue) return null;

    const baseDate = new Date(dueDate);
    const daysToAdd = parseInt(requestedDaysValue, 10);

    if (isNaN(daysToAdd)) return null;

    const newDate = new Date(baseDate);
    newDate.setDate(baseDate.getDate() + daysToAdd);

    return newDate;
  };
  const handleSave = async () => {
    try {
      const errors = [];
      if (!extensionRequestedDate) {
        errors.push("Please select Extension Requested Date");
      }
      // if (!requestedDays) {
      //   errors.push("Please select Extension Duration");
      // }
      if (fileIds.length > 0) {
        if (!documentType) {
          errors.push("Please select Document Type");
        }
        if (!sender) {
          errors.push("Please select Sender");
        }
      }

      if (statusName == "Approved" || statusName == "Denied") {
        if (!approvedonDate) {
          errors.push("Please select Approved/Denied On Date");
        }
      }
      if (errors?.length > 0) {
        setSnackbarMessage(errors.join("\n"));
        setSnackbarOpen(true);
        setError("error");
        return false;
      }
      const requestBody = {
        subjectQmeScheduleID: subjectQmeScheduleID,
        dateRequested: extensionRequestedDate
          ? formatDateForApi(extensionRequestedDate)
          : null,
        extensionRequestedDaysId: requestedDays,
        extensionRequestedReasonId: selectedReason,
        dwcExtensionStatusId: Number(status),
        typeOfTest: typeofTest,
        comments: comments,
        newDueDate: newDueDate ? formatDateForApi(newDueDate) : null,
        approvedOn: approvedonDate ? formatDateForApi(approvedonDate) : null,
        documentTypeId: documentType ?? 0,
        senderKeyId: sender ?? 0,
        senderKeyCode: senderCode ?? "",
        provisionalAttachmentIds: fileIds.join(","),
      };
      const requestBodyUpdate = {
        dateRequested: extensionRequestedDate
          ? formatDateForApi(extensionRequestedDate)
          : null,
        dwcExtensionId: dwcExtensionId,
        subjectQmeScheduleID: subjectQmeScheduleID,
        extensionRequestedDaysId: requestedDays,
        extensionRequestedReasonId: selectedReason,
        dwcExtensionStatusId: Number(status),
        typeOfTest: typeofTest,
        comments: comments,
        newDueDate: newDueDate ? formatDateForApi(newDueDate) : null,

        approvedOn: approvedonDate ? formatDateForApi(approvedonDate) : null,
        provisionalAttachmentIds: fileIds.join(","),
        senderKeyCode: senderCode ?? "",
        documentTypeId: documentType ?? 0,
        senderKeyId: sender ?? 0,
      };
      let response;

      if (dwcExtensionId != null) {
        response = await updateDwcExtension(requestBodyUpdate);
        setStatusName(response.dwcExtensionStatus);
      } else {
        response = await addDWCExtension(requestBody);
        setStatusName(response.dwcExtensionStatus);
      }

      if (response.isSuccess) {
        setDwcExtensionId(response.result);
        setSnackbarMessage("Extension Request saved successfully");
        if (selectedRows.selectedRows != EDITOR_REPORT_STATUS.COMPLETED) {
          const emailResponse = await getEditorExtensionEmail(
            subjectQmeScheduleID,
            statusName,
          );
        }
        setError("success");
        setSnackbarOpen(true);
        await new Promise((resolve) => setTimeout(resolve, 1500));
        onSaveSuccess(statusName);
        fetchExtensionDetails(subjectQmeScheduleID);
        fetchLogsData(subjectQmeScheduleID);
      } else {
        setSnackbarMessage("Failed to save Extension Request");
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("Failed to save extension request details");
      setError("error");
      setSnackbarOpen(true);
    }
  };
  const date = new Date();
  const today = currentDueDate
    ? new Date(currentDueDate).toISOString().split("T")[0]
    : null;

  const minDate = currentDueDate
    ? new Date(
        new Date(currentDueDate).setDate(
          new Date(currentDueDate).getDate() - 5,
        ),
      )
    : null;
  return (
    <div>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      <div>
        <label className="me-2" style={{ fontWeight: 500 }}>
          Action:
        </label>

        {/* Request Box */}
        {/* Requested Box */}
        <div className="dwc-radio-action-box d-inline-flex align-items-center px-3 py-2 me-3">
          {statusOptions
            .filter((item) => item.label === "Requested")
            .map((item) => (
              <label
                key={item.value}
                className="d-inline-flex align-items-center m-0"
              >
                <input
                  type="radio"
                  name="status"
                  value={item.value}
                  checked={status === item.value}
                  disabled={dwcStatus === "Denied" || dwcStatus === "Approved"}
                  onChange={() => {
                    setStatus(item.value);
                    setStatusName(item.label);
                  }}
                  className="form-check-input me-2"
                />
                {item.label}
              </label>
            ))}
        </div>

        {/* Approved + Denied Box */}
        <div className="dwc-radio-action-box d-inline-flex align-items-center px-3 py-2">
          {statusOptions
            .filter(
              (item) => item.label === "Approved" || item.label === "Denied",
            )
            .map((item) => (
              <label
                key={item.value}
                className="d-inline-flex align-items-center me-3 m-0"
              >
                <input
                  type="radio"
                  name="status"
                  value={item.value}
                  checked={status === item.value}
                  disabled={dwcStatus === "Denied" || dwcStatus === "Approved"}
                  onChange={() => {
                    setStatus(item.value);
                    setStatusName(item.label);
                  }}
                  className="form-check-input me-2"
                />

                {item.label}
              </label>
            ))}
        </div>
      </div>

      <Row className="mt-3">
        <Col sm={4}>
          <FloatingLabelDatepicker
            label="Extension Requested Date"
            name="Date"
            value={extensionRequestedDate}
            minDate={minDate}
            maxDate={today}
            onChange={(date: Date | null) => setextensionRequestedDate(date)}
            required
            dateFormat="MM/dd/yyyy"
            disabled={
              dwcStatus === "Denied" ||
              dwcStatus === "Approved" ||
              (statusName === "Approved" && dwcExtensionId !== null)
            }
          />
        </Col>
        {(statusName === "Approved" ||
          statusName === "Denied" ||
          dwcStatus == "Approved" ||
          dwcStatus === "Denied") && (
          <Col sm={4}>
            <FloatingLabelDatepicker
              label="Approved/Denied on"
              name="Date"
              value={approvedonDate}
              minDate={minDate}
              maxDate={today}
              onChange={(date: Date | null) => setApprovedonDate(date)}
              required
              dateFormat="MM/dd/yyyy"
              disabled={dwcStatus == "Denied" || dwcStatus == "Approved"}
            />
          </Col>
        )}
        <Col sm={4}>
          <FloatingLabelDatepicker
            label="Current Due Date"
            name="Date"
            value={currentDueDate}
            minDate={today}
            disabled
            onChange={(date: Date | null) => setcurrentDueDate(date)}
            dateFormat="MM/dd/yyyy"
          />
        </Col>
      </Row>

      <div>
        <Row className="mt-3">
          {renderAccordion([
            {
              title: "Extension Request",
              content: (
                <div>
                  <Row className="align-items-center mt-1 mb-0">
                    {/* Label */}
                    <Col sm={4}>
                      <label className="fw-medium">Extension Duration:</label>
                    </Col>

                    {/* Toggle Buttons */}
                    <Col sm={4}>
                      <ToggleButtonGroup
                        type="radio"
                        name="extensionOptions"
                        value={requestedDaysValue}
                        className="appointment-ui d-flex gap-2"
                      >
                        {requestedDaysOptions.map((opt) => (
                          <ToggleButton
                            key={opt.id}
                            id={`btn-${opt.value}`}
                            value={opt.label}
                            checked={requestedDaysValue === opt.label}
                            disabled={
                              dwcStatus === "Denied" ||
                              dwcStatus === "Approved" ||
                              (statusName === "Approved" &&
                                dwcExtensionId !== null)
                            }
                            variant={
                              requestedDaysValue === opt.label
                                ? "primary"
                                : "outline-primary"
                            }
                            onClick={() => {
                              setRequestedDays(opt.value);
                              setRequestedDaysValue(opt.label);
                              const newDue = calculateNewDueDate(
                                selectedRows?.[0]?.dueDate,
                                opt.label,
                              );

                              setnewDueDate(newDue);
                              settypeofTest("");
                            }}
                          >
                            {opt.label}
                          </ToggleButton>
                        ))}
                      </ToggleButtonGroup>
                    </Col>

                    {/* Date Picker */}
                    <Col sm={4}>
                      <FloatingLabelDatepicker
                        label="New Due Date"
                        name="Date"
                        value={newDueDate}
                        minDate={today}
                        onChange={(date: Date | null) => setnewDueDate(date)}
                        dateFormat="MM/dd/yyyy"
                        disabled
                      />
                    </Col>
                  </Row>

                  <Row className="mt-3">
                    <label className="fw-semibold mb-2">
                      Indicate the reason for the request below:
                    </label>

                    {requestedDaysValue === "15 Days" && (
                      <div className="ms-2">
                        {fifteenDayReasons.map((item) => (
                          <div key={item.id} className="mb-1">
                            <label className="d-flex align-items-center text-muted">
                              <input
                                type="radio"
                                name="selectedReason"
                                checked={selectedReason === item.value}
                                onChange={() => setSelectedReason(item.value)}
                                disabled={isReasonDisabled}
                                className="me-2"
                              />
                              {item.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}

                    {requestedDaysValue === "30 Days" && (
                      <div className="ms-2">
                        {thirtyDayReasons.map((item, index) => (
                          <div key={item.id} className="mb-2">
                            {/* ✅ First option */}
                            {index === 0 && (
                              <>
                                <label className="d-flex align-items-center">
                                  <input
                                    type="radio"
                                    name="selectedReason"
                                    checked={selectedReason === item.value}
                                    onChange={() =>
                                      setSelectedReason(item.value)
                                    }
                                    disabled={isReasonDisabled}
                                    className="me-2"
                                  />
                                  {item.label}
                                  <span className="ms-1 fw-normal">
                                    Type of Test:
                                  </span>
                                </label>

                                <div className="mt-2">
                                  <MultilineTextBox
                                    label="Comments"
                                    name="comments"
                                    value={typeofTest}
                                    disabled={isReasonDisabled}
                                    onChange={(e) =>
                                      settypeofTest(e.target.value)
                                    }
                                  />
                                </div>
                              </>
                            )}

                            {/* ✅ Other options */}
                            {index !== 0 && (
                              <label className="d-flex align-items-center">
                                <input
                                  type="radio"
                                  name="selectedReason"
                                  checked={selectedReason === item.value}
                                  onChange={() => setSelectedReason(item.value)}
                                  disabled={isReasonDisabled}
                                  className="me-2"
                                />
                                {item.label}
                              </label>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </Row>
                </div>
              ),
            },
          ])}
        </Row>
      </div>
      <div>
        {addnotefileAccordion([
          {
            title: "Attachment(s)",
            content: (
              <>
                <Row>
                  <Col sm={6} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Document Type"
                      name="documentType"
                      disabled={
                        dwcStatus === "Denied" ||
                        dwcStatus === "Approved" ||
                        (statusName === "Approved" && dwcExtensionId !== null)
                      }
                      options={documentTypeOptions}
                      value={documentType}
                      onChange={(e, name, value) => {
                        setDocumentType(value);
                      }}
                    />
                  </Col>
                  <Col sm={6} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Sender"
                      name="sender"
                      options={senderOptions}
                      value={sender}
                      disabled={
                        dwcStatus === "Denied" ||
                        dwcStatus === "Approved" ||
                        (statusName === "Approved" && dwcExtensionId !== null)
                      }
                      onChange={(e, name, value) => {
                        setSender(value);
                        const selectedCode = senderOptions?.find(
                          (item) => item.value === value,
                        );
                        if (selectedCode) {
                          setSenderCode(selectedCode?.partyCode || "");
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row className="align-items-center mt-3">
                  <EditableFileTable
                    caseInfoId={caseInfoId}
                    comments={comments}
                    onFileIdsUpdate={handleFileIdsUpdate}
                    result={result}
                    isCancel={isCancel}
                    documentType={documentCategory}
                    isRowActionTriggered={false}
                    isdisable={false}
                  />
                </Row>
              </>
            ),
          },
        ])}
      </div>
      <div>
        {addlogAccordion([
          {
            title: "Log(s)",
            content: (
              <>
                <Row>
                  <DataTable headers={LOG_HEADERS} rows={logRows} />
                </Row>
              </>
            ),
          },
        ])}
      </div>

      <Row className="mb-3">
        <Col>
          <TextInput
            label="Comments"
            name="Type of Test:"
            value={comments}
            onChange={(e) => setcomments(e.target.value)}
            maxLength={100}
            disabled={
              dwcStatus === "Denied" ||
              dwcStatus === "Approved" ||
              (statusName === "Approved" && dwcExtensionId !== null)
            }
          />
        </Col>
      </Row>
      <Modal show={showModalNew} onHide={handleCloseModalNew}>
        <Modal.Body className="fw-bold text-left modelheading ">
          <div>Are you sure you want to cancel?</div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalNew}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            onClick={handleConfirmCancelButton}
            variant="primary"
            className="ms-3 d-flex align-items-center"
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Row className="mt-3 align-items-center">
        <Col className="d-flex">
          {dwcExtensionId !== null && (
            <Button
              variant="outline"
              className="btn d-flex align-items-center btn-text-border"
              onClick={() => downloadExtensionFormpdf()}
            >
              <span className="material-icons mx-1">download</span>
              Generate Extension Form
            </Button>
          )}
        </Col>

        {/* RIGHT SIDE */}
        <Col className="d-flex justify-content-end gap-2">
          <Button
            variant="outline-info"
            className="d-flex align-items-center"
            onClick={handleCancel}
            disabled={dwcStatus == "Denied"}
          >
            <span className="material-icons mr-2">close</span>
            Cancel
          </Button>

          <Button
            variant="primary"
            className="d-flex align-items-center"
            onClick={handleSave}
            disabled={dwcStatus == "Denied" || dwcStatus == "Approved"}
          >
            <span className="material-icons mx-1">save</span>
            Save
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default EditorDWCExtensionRequest;
